import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const Theaters = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddTheater = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditTheater = () => {
  return (
    
      
        <Edit />
      
    
  );
};
